import {call, put, select, takeLatest} from "redux-saga/effects";
import * as actions from "../action.constants";
import {
  saveCustomerUserProfile,
  saveUserProfile,
  saveUserResources,
  saveUsersList,
  storeOrgUsers,
} from "../Actions/users.action";
import {
  changeOwnerAsync,
  createUser,
  deleteUser,
  editUser,
  getCustomerUserProfileAsync,
  getOrgUsersAsync,
  getUserProfileAsync,
  getUserResourcesAsync,
  getUsers,
  saveUserSettingsAsync,
} from "../AsyncActions/users.async";
import {getOrganization} from "../Selectors/general.selectors";
import {getCustomerUserProfile} from "../Selectors/users.selector";

function* getUserList(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const response = yield call(getUsers, pageUrl);
    if (response) {
      yield put(saveUsersList(response?.data));
    }
  } catch (e) {
    return e;
  }
}

function* createUserRequest(action = {}) {
  const {payload, callback = () => {}} = action;

  try {
    const response = yield call(createUser, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* editUserRequest(action = {}) {
  const {payload, callback = () => {}} = action;

  try {
    const response = yield call(editUser, payload);
    if (response) {
      callback();
      callback(response.data);
    }
  } catch (e) {
    return e;
  }
}

function* deleteUserRequest(action) {
  const {payload, callback = () => {}} = action;
  try {
    const response = yield call(deleteUser, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* getUserProfileSaga() {
  try {
    const response = yield call(getUserProfileAsync);
    if (response.data?.data) {
      yield put(saveUserProfile(response?.data?.data));
    }
  } catch (e) {
    return e;
  }
}

function* getCustomerUserProfileSaga() {
  try {
    const response = yield call(getCustomerUserProfileAsync);
    if (response.data?.data) {
      yield put(saveCustomerUserProfile(response?.data?.data));
    }
  } catch (e) {
    return e;
  }
}

function* getOrgUsers() {
  try {
    const currentUser = yield select(getCustomerUserProfile);
    const response = yield call(getOrgUsersAsync, currentUser.id);
    if (response?.data) {
      yield put(storeOrgUsers(response?.data?.data));
    }
  } catch (e) {
    return e;
  }
}

function* changeOwner(action) {
  const {payload, callback} = action;
  const organization = yield select(getOrganization);
  try {
    const response = yield call(changeOwnerAsync, payload, organization?.id);
    if (response) {
      yield call(getUserList, {pageUrl: ""});
      yield call(getUserProfileSaga);
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* getUserResources() {
  try {
    const response = yield call(getUserResourcesAsync);
    if (response.data?.data) {
      yield put(saveUserResources(response.data.data));
    }
  } catch (e) {
    return e;
  }
}

function* saveUserSettingsSaga(action) {
  const {payload} = action;
  try {
    const response = yield call(saveUserSettingsAsync, payload);
    if (response) {
      yield call(getCustomerUserProfileSaga);
    }
  } catch (e) {
    return e;
  }
}

export function* sitesSaga() {
  yield takeLatest(actions.REQUEST_SEND_ADD_USER_DATA_SAGA, createUserRequest);
  yield takeLatest(actions.REQUEST_GET_USERS_LIST_SAGA, getUserList);
  yield takeLatest(actions.REQUEST_SEND_EDIT_USER_DATA_SAGA, editUserRequest);
  yield takeLatest(actions.REQUEST_DELETE_USER_SAGA, deleteUserRequest);
  yield takeLatest(actions.GET_USER_PROFILE, getUserProfileSaga);
  yield takeLatest(actions.GET_CUSTOMER_USER_PROFILE, getCustomerUserProfileSaga);
  yield takeLatest(actions.REQUEST_ORG_USERS, getOrgUsers);
  yield takeLatest(actions.CHANGE_OWNER, changeOwner);
  yield takeLatest(actions.REQUEST_USER_RESOURCES, getUserResources);
  yield takeLatest(actions.SAVE_USER_SETTINGS, saveUserSettingsSaga);
}
